import QuoteBlock from './quoteBlock';

export default QuoteBlock;
